import { render, staticRenderFns } from "./WhirelabInput.vue?vue&type=template&id=55ff7584&scoped=true"
import script from "./WhirelabInput.vue?vue&type=script&lang=js"
export * from "./WhirelabInput.vue?vue&type=script&lang=js"
import style0 from "./WhirelabInput.vue?vue&type=style&index=0&id=55ff7584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff7584",
  null
  
)

export default component.exports